export default __webpack_public_path__ + "static/social-ea854ab10413f43fcc0d194dfbc0318c.png";